module.exports = __webpack_public_path__ + "img/napoli-small.3fccbd00.svg";